/*
 * Protected storefront cart hardening for Pipeline 8.2.0.
 * Liquid removes normal purchase controls. This guard keeps Ajax-rendered carts
 * protected if an On Hold, POA, or unavailable variant reaches the cart through stale state.
 */
(() => {
  let latestCart = null;

  const formatMoney = (cents, currencyDisplay = 'code') => {
    const currency = latestCart?.currency || window.theme?.currencyCode || 'AUD';
    const locale = document.documentElement.lang || 'en-AU';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        currencyDisplay
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const setText = (element, value) => {
    if (element && element.textContent.trim() !== value) {
      element.textContent = value;
    }
  };

  const protectCheckout = (element, protectedState) => {
    if (!element) return;

    if (protectedState && element.dataset.poaGuarded !== 'true') {
      element.dataset.poaGuarded = 'true';
      element.dataset.poaDisplay = element.style.display || '';
      if ('disabled' in element) {
        element.dataset.poaDisabled = element.disabled ? 'true' : 'false';
        element.disabled = true;
      }
      element.style.display = 'none';
    } else if (!protectedState && element.dataset.poaGuarded === 'true') {
      element.style.display = element.dataset.poaDisplay || '';
      if ('disabled' in element) {
        element.disabled = element.dataset.poaDisabled === 'true';
      }
      delete element.dataset.poaGuarded;
      delete element.dataset.poaDisplay;
      delete element.dataset.poaDisabled;
    }
  };

  const syncProtectedCart = () => {
    const hasOnHold = Boolean(document.querySelector('[data-on-hold-cart-item]'));
    const hasPoa = Boolean(document.querySelector('[data-poa-cart-item]'));
    const hasSold = Boolean(document.querySelector('[data-sold-cart-item]'));
    const hasItems = Boolean(document.querySelector('[data-cart-item]'));
    const isLoading = Boolean(document.querySelector('[data-cart-loading].cart--loading'));
    const hasProtectedItem = hasOnHold || hasPoa || hasSold || !hasItems || isLoading;

    document.querySelectorAll('[name="checkout"], .additional-checkout-buttons, .drawer__checkout__additional')
      .forEach((element) => protectCheckout(element, hasProtectedItem));

    document.querySelectorAll('[data-cart-message]')
      .forEach((element) => protectCheckout(element, hasProtectedItem));

    document.querySelectorAll('[data-header-cart-price]').forEach((element) => {
      if (hasOnHold) {
        element.setAttribute('data-header-cart-price', '');
        setText(element, 'On Hold');
      } else if (hasPoa) {
        element.setAttribute('data-header-cart-price', '');
        setText(element, 'POA');
      } else if (hasSold) {
        element.setAttribute('data-header-cart-price', '');
        setText(element, 'Sold Out');
      } else if (latestCart) {
        element.setAttribute('data-header-cart-price', String(latestCart.total_price));
        setText(element, formatMoney(latestCart.total_price, 'symbol'));
      }
    });

    document.querySelectorAll('[data-cart-final]').forEach((element) => {
      if (hasOnHold) {
        setText(element, 'On Hold');
      } else if (hasPoa) {
        setText(element, 'POA');
      } else if (hasSold) {
        setText(element, 'Sold Out');
      } else if (latestCart) {
        setText(element, formatMoney(latestCart.total_price, 'code'));
      }
    });
  };

  document.addEventListener('theme:cart:change', (event) => {
    latestCart = event.detail?.cart || latestCart;
    window.requestAnimationFrame(syncProtectedCart);
  });

  document.addEventListener('DOMContentLoaded', syncProtectedCart);

  const observer = new MutationObserver(() => window.requestAnimationFrame(syncProtectedCart));
  observer.observe(document.documentElement, { childList: true, subtree: true });

  syncProtectedCart();
})();
